import React from 'react';
import PropTypes from 'prop-types';

const GuestGuard = ({children}) => {

    return <div>{children}</div>;
};

GuestGuard.propTypes = {
    children: PropTypes.node
};

export default GuestGuard;
